"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastPlayerSpeed = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const speedOptionValues = new Set([0.75, 1, 1.25, 1.5, 2]);
const speedIcons = {
    '0.75': 'speed-0-75',
    '1': 'speed-1x',
    '1.25': 'speed-1-25',
    '1.5': 'speed-1-5x',
    '2': 'speed-2x',
};
const PodcastPlayerSpeed = ({ audioRef, activeModal, setActiveModal, }) => {
    const [speed, setSpeed] = React.useState(1);
    const containerRef = React.useRef(null);
    const [speedIcon, setSpeedIcon] = React.useState('speed-1x');
    const changeSpeed = React.useCallback((event) => {
        const newSpeed = Number(event.target.value);
        const audio = audioRef.current;
        if (audio && newSpeed !== speed) {
            if (speedOptionValues.has(newSpeed)) {
                setSpeedIcon(speedIcons[newSpeed]);
                audio.playbackRate = newSpeed;
            }
            setSpeed(newSpeed);
        }
    }, [audioRef, speed]);
    const handleSpeedVisibilityToggle = () => {
        if (activeModal === 'speed') {
            setActiveModal(null);
        }
        else {
            setActiveModal('speed');
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { ref: containerRef, className: "podcast-player__speed podcast-player-speed relative flex-center size-[42px] text-secondary", children: [activeModal === 'speed' && ((0, jsx_runtime_1.jsx)("div", { className: "podcast-player-speed__menu p-md bg-surface-primary -top-sm absolute flex h-[116px] w-[40px] translate-y-[-100%] items-center justify-center rounded-2xl shadow-md", children: (0, jsx_runtime_1.jsx)("input", { className: "h-[2px] w-[80px] origin-center rotate-[-90deg] cursor-pointer [appearance:none] [&::-moz-range-thumb]:mt-[-7px] [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-black [&::-moz-range-track]:h-[2px] [&::-moz-range-track]:bg-black [&::-webkit-slider-runnable-track]:h-[2px] [&::-webkit-slider-runnable-track]:bg-black [&::-webkit-slider-thumb]:relative [&::-webkit-slider-thumb]:top-1/2 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:translate-y-[-50%] [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-black", id: "speed-slider", type: "range", min: 0.75, max: 2, step: 0.05, value: speed, "aria-valuemin": 0.75, "aria-valuemax": 2, "aria-valuenow": speed, "aria-label": "Playback speed", onChange: changeSpeed }) })), (0, jsx_runtime_1.jsx)("button", { className: `podcast-player-speed__btn text-icon-primary active:bg-fill-primary-pressed p-2xs relative flex h-10 w-10 items-center justify-center rounded-full ${activeModal === 'speed'
                    ? 'bg-fill-primary-pressed hover:bg-fill-primary-pressed'
                    : 'hover:bg-fill-primary-hovered'}`, type: "button", "aria-haspopup": "true", "aria-expanded": "false", "data-speed-button": "", "data-popover-init": "true", "aria-controls": "data-speed-button-ol3yksfvkh", onClick: handleSpeedVisibilityToggle, children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: speedIcon }) })] }));
};
exports.PodcastPlayerSpeed = PodcastPlayerSpeed;
